import * as React from "react";
import { useState } from "react";

export interface IInputStepperTextProps {
  maxValue : number;
  value: number;
  enableTextInput: boolean;
  onChangeValue : (value : number) => void;
}

export const InputStepperText = (props : IInputStepperTextProps) => {
  const [value, setValue] = useState(props.value);

  const decreaseValue = (event) => {
    event.preventDefault();
    if (value > 1) {
      const newValue = value - 1;
      setValue(newValue);
      props.onChangeValue(newValue);
    }
    return false;
  };

  const increaseValue = (event) => {
    event.preventDefault();
    if (value < props.maxValue) {
      const newValue = value + 1;
      setValue(newValue);
      props.onChangeValue(newValue);
    }
    return false;
  };

  const changeValue = (event) => {
    event.preventDefault();
    const newValue = parseInt(event.target.value);
    if(newValue < props.maxValue && newValue >= 0){
      setValue(newValue);
      props.onChangeValue(newValue);
    }
    return false;    
  };

  return <div className="input-stepper">
    <a href="#" onClick={decreaseValue} className="input-stepper__min"><span className="icon icon-minus"></span></a>
    <div className="input-stepper__indicator">
      <input type="number" disabled={!props.enableTextInput} onChange={changeValue} value={value} className="input-stepper__input input-stepper__input--no-default-behaviour"></input>    
    </div>    
    <a href="#" onClick={increaseValue} className="input-stepper__plus"><span className="icon icon-plus"></span></a>
  </div>;
};